import { types } from "../action-types";

const getInitials = (fullName = "") => {
  const parts = fullName.trim().split(" ").filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`;
  if (parts.length === 1) return parts[0][0];
  return "?";
};

const normalizeItem = (item) => ({
  _id: item.profile_id,
  id: item.profile_id,
  name: item.full_name || "",
  title: item.title || item.headline || "",
  avatar: item.profile_picture_url || null,
  initials: getInitials(item.full_name),
  online: false,
  aiScore: null,
  totalExperience: item.totalExperience
    ? `${item.totalExperience} yr${item.totalExperience !== 1 ? "s" : ""}`
    : "",
  location: item.location || item.country || "",
  estimatedAmount: "",
});

const initialState = {
  loading: false,
  error: false,
  data: [],
  totalCount: 0,
  displayedTotalCount: 0,
  pageSize: 25,
};

const searchExternalUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_EXTERNAL_USERS_INIT:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case types.SEARCH_EXTERNAL_USERS_SUCCESS: {
      // Response shape: { status, data: { source, metadata, profiles: [...] } }
      const inner = action.payload?.data || action.payload;

      const profiles = Array.isArray(inner?.profiles)
        ? inner.profiles
        : Array.isArray(action.payload)
        ? action.payload
        : [];

      const metadataTotal = inner?.metadata?.total ?? inner?.metadata?.total_results ?? 0;
      const totalCount = metadataTotal > 0 ? metadataTotal : profiles.length;
      const pageSize = inner?.metadata?.per_page || inner?.metadata?.page_size || state.pageSize || 25;

      return {
        ...state,
        loading: false,
        error: false,
        data: profiles.map(normalizeItem),
        totalCount,
        displayedTotalCount: totalCount,
        pageSize,
      };
    }

    case types.SEARCH_EXTERNAL_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
        totalCount: 0,
      };

    case types.SEARCH_EXTERNAL_USERS_CLEAR:
      return { ...initialState };

    default:
      return state;
  }
};

export default searchExternalUsersReducer;
